import { IoCreateOutline } from "react-icons/io5"
import "./style.css"

export default function BtnCadastrar() {
    return (
        <button id="btnCadastrarDefault" type="submit">Cadastar <IoCreateOutline /></button>
    )
}